import type { ReactNode } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type DisabledReasonTooltipProps = {
  reason?: string | undefined;
  children: ReactNode;
};

/**
 * Renders a disabled-state tooltip only when a reason exists; otherwise returns children unchanged.
 */
export function DisabledReasonTooltip({
  reason,
  children,
}: DisabledReasonTooltipProps) {
  if (!reason) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex w-fit cursor-not-allowed" tabIndex={0}>
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent>{reason}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
